import styled, { css, keyframes } from 'styled-components';

export const EntryForm = styled.form`
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    max-width: 360px;
    height: 24px;
    padding: 0 2px 0 6px;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.tokens?.BaseColorWhite};
    border: 1px solid ${({ theme }) => theme.tokens?.BaseColorGray300};
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);

    &:hover {
        border-color: ${({ theme }) => theme.tokens?.BaseColorBlue700};
    }

    &:focus-within {
        border-color: ${({ theme }) => theme.tokens?.BaseColorBlue700};
        box-shadow: 0 0 0 1px ${({ theme }) => theme.tokens?.BaseColorBlue700};
    }

    svg.deal-assistant-entry-logo {
        flex: none;
        width: 20px;
        height: 20px;
    }
`;

const promptInEven = keyframes`
    from {
        opacity: 0;
        transform: translateY(2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const promptInOdd = keyframes`
    0% {
        opacity: 0;
        transform: translateY(2px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const EntryInput = styled.input<{ $promptIndex: number }>`
    flex: 1;
    min-width: 0;
    height: 20px;
    padding: 0;
    border: 0;
    outline: 0;
    background: transparent;
    font: inherit;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.3;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.tokens?.BaseColorBlack};

    &::placeholder {
        color: ${({ theme }) => theme.tokens?.BaseColorGray600};
        opacity: 1;
        ${({ $promptIndex }) => css`
            animation: ${$promptIndex % 2 ? promptInOdd : promptInEven} 0.35s ease-out;
        `}
    }

    @media (prefers-reduced-motion: reduce) {
        &::placeholder {
            animation: none;
        }
    }
`;

export const EntrySendButton = styled.button`
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.tokens?.BaseColorBlue600};
    color: ${({ theme }) => theme.tokens?.BaseColorWhite};
    cursor: pointer;

    &:disabled {
        background-color: ${({ theme }) => theme.tokens?.BaseColorGray300};
        cursor: not-allowed;
    }

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const EntryReason = styled.p`
    margin: 2px 0 0;
    font-size: 11px;
    line-height: 1.2;
    color: ${({ theme }) => theme.tokens?.BaseColorGray600};
`;
